import { getJson } from '../fetch';
import API_BASE_PATH from './basePath';

const getRoles = () => getJson(`${API_BASE_PATH}/roles`);

export default getRoles;
